import { Route } from "@angular/router";

export const VzwHelperPaths = {
  Start: "start",
};

export default [
  {
    path: VzwHelperPaths.Start,
    loadComponent: () =>
      import("../menu/pages/on-hold/on-hold.component").then((c) => c.OnHoldComponent),
    data: {
      breadcrumb: "Vzw-Helper",
      title: "Vzw-Helper",
      previousVersionUrl: "https://app.assistonline.eu/dba/#/app/vzw-helper",
      webinarUrl: "https://www.youtube.com/embed/---sdPfyKOk?si=JKCZ3hQKtQWGd02_",
      subscriptionTypes: [1, 4],
    },
  },
] satisfies Route[];
